module.exports = __webpack_public_path__ + "img/feed-icon.0cd3d75d.svg";